import React from 'react'
import { Container, Grid as GridBase, Chip, styled } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info'

export const Wrapper = styled(Container)``

export const GridWrapper = styled(({ align, margin, minHeight, padding, ...props }) => <GridBase {...props} />)`
  margin: ${props => props.margin};

  &.MuiGrid-item {
    margin: ${props => props.margin};
    min-height: ${props => props.minHeight};
  }

  &.barChart-container {
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &.CardGridWrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  padding: ${props => props.padding};
  text-align: ${props => props.align};
`

export const Info = styled(InfoIcon)`
  position: relative;
  top: 2px;
  margin-left: 5px;
  width: 16px;
  height: 16px;
  color: ${props => props.theme.palette.brand.black1};

  &.MuiSvgIcon-root {
    font-size: 1rem;
  }
`

export const ContractLabel = styled(Chip)`
  color: ${props => props.theme.palette.red[50]};
  background-color: ${props => props.theme.palette.red[90]};
  border-radius: 4px;
  padding: 8px 4px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.12px;
`

export const Exportable = styled('div')``

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  text-decoration: underline;
  cursor: pointer;
`

export const ModalContainer = styled('div')`
  padding: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Strong = styled('strong')``
